import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/error.js");
